import * as React from 'react';
import classnames from 'classnames';
import Divider from '@components/shared/Divider';
import s from './Card.module.less';

type Props = {
  className?: string;
  title: string;
  children: React.ReactNode;
  'data-testid'?: string;
};

/* eslint-disable react/destructuring-assignment */
const Card = ({ className, title, children, ...props }: Props) => (
  <section data-testid={props['data-testid']} className={classnames(s.card, className)}>
    <h3 className={s.title}>{title}</h3>
    <Divider />
    <div className={s.content}>{children}</div>
  </section>
);
/* eslint-enable react/destructuring-assignment */

export default Card;
